import React from 'react';
import { Check, X } from 'lucide-react';
import { useInView } from '../hooks/useInView';
export function ForWhoSection() {
  const {
    ref,
    isVisible
  } = useInView();
  const forYou = ['te culpas si trabajas y te culpas si no', 'sientes que nunca alcanza', 'estás cansada de vivir "compensando"', 'quieres paz práctica, no discursos'];
  const notForYou = ['buscas un proceso clínico profundo aquí mismo', 'no estás dispuesta a hacer 10 minutos diarios por 14 días'];
  return <section ref={ref} className="w-full bg-white py-10 px-6 md:py-14" data-id="element-18">
      <div className={`max-w-4xl mx-auto fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-19">
        <div className="grid md:grid-cols-2 gap-6" data-id="element-20">
          <div className="bg-cream/50 p-6 rounded-xl border border-gold/20" data-id="element-21">
            <h3 className="font-serif text-2xl text-navy font-bold mb-4 flex items-center gap-2" data-id="element-22">
              <span className="bg-green-100 text-green-700 p-1 rounded-full" data-id="element-23">
                <Check className="w-5 h-5" data-id="element-24" />
              </span>
              Esto es para ti si:
            </h3>
            <ul className="space-y-3" data-id="element-25">
              {forYou.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-26">
                  <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-27" />
                  <span className="font-sans text-text-dark" data-id="element-28">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-29">
            <h3 className="font-serif text-2xl text-text-muted font-bold mb-4 flex items-center gap-2" data-id="element-30">
              <span className="bg-gray-200 text-gray-500 p-1 rounded-full" data-id="element-31">
                <X className="w-5 h-5" data-id="element-32" />
              </span>
              No es para ti si:
            </h3>
            <ul className="space-y-3" data-id="element-33">
              {notForYou.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-34">
                  <X className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-35" />
                  <span className="font-sans text-text-muted" data-id="element-36">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}